

import React, { memo } from 'react';
import cx from 'classnames';
import ReviewMember from './ReviewMember';
import '../styles/_review-members.scss';







const ReviewMembers = ({ className = '', members, imageSize }) =>
<div className={cx('review-members', className)}>
    {
  members && Array.isArray(members) && members.length ?
  members.map((member) =>
  <ReviewMember key={member.userId} imageSize={imageSize} className="review-members__member" member={member} />
  ) :
  null}

  </div>;


export default memo(ReviewMembers);